import { cva, type VariantProps } from "class-variance-authority"
import * as React from "react"

import { cn } from "../lib/utils"

const iconButtonVariants = cva(
  "inline-flex items-center justify-center rounded-full transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        solid: "bg-primary text-bg-white hover:bg-primary/90 disabled:bg-disabled",
        outlined:
          "border border-border bg-bg-white text-text hover:bg-background disabled:border-disabled disabled:text-text-disabled",
        overlay: "bg-highlight text-text hover:bg-highlight/80 backdrop-blur-sm",
      },
      size: {
        sm: "size-8 [&_svg]:size-4",
        default: "size-9 [&_svg]:size-5",
        lg: "size-11 [&_svg]:size-6",
      },
    },
    defaultVariants: {
      variant: "solid",
      size: "default",
    },
  }
)

export interface IconButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof iconButtonVariants> {}

const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ className, variant, size, ...props }, ref) => (
    <button ref={ref} className={cn(iconButtonVariants({ variant, size, className }))} {...props} />
  )
)
IconButton.displayName = "IconButton"

export { IconButton, iconButtonVariants }
